const TRACK_ACTIVITY = {
    trackActivity: "/frontend/track-activity",
    activityStart: "/frontend/activity/start",
    activityPing: "/frontend/activity/ping",
    activityEnd: "/frontend/activity/end",
    activationTrack: "/frontend/activation/track",
};

export default TRACK_ACTIVITY;
